import { jsx as _jsx } from "react/jsx-runtime";
import { conversationStatusAttributes } from 'utils/conversation/conversationAttributes';
import { ConversationsStaticFilter } from '../static/conversationsStaticFilter';
/** The list of statuses conversations can be filtered by. */
const statuses = Object.keys(conversationStatusAttributes)
    // Exclude `awaitingpending` as it is covered by the `open` status.
    .filter((status) => status !== 'awaitingpending')
    .map((status) => ({
    id: status,
    name: conversationStatusAttributes[status].label,
}));
/** Represents the component for filtering the conversations by status. */
export const ConversationsStatusFilter = () => (_jsx(ConversationsStaticFilter, { type: "status", items: statuses }));
